import { render } from "./MeetingViewConfiguration.vue?vue&type=template&id=8f4e45be"
import script from "./MeetingViewConfiguration.vue?vue&type=script&lang=js"
export * from "./MeetingViewConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agent-2\\_work\\118\\s\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__